import { useState } from 'react';

export const useToggle = (initialValue = false) => {
    const [state, setState] = useState(initialValue);
    const setOpen = () => setState(true);
    const setClose = () => setState(false);
    const toggle = () => setState((p) => !p);

    return { open: state, toggle, setOpen, setClose };
};
